import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import styles from './LoadingSpinner.module.scss.js';

function LoadingSpinner(_a) {
    var _b = _a.isLoading, isLoading = _b === void 0 ? false : _b, _c = _a.size, size = _c === void 0 ? 'medium' : _c, _d = _a.centered, centered = _d === void 0 ? false : _d, _e = _a.relative, relative = _e === void 0 ? false : _e, _f = _a.overlay, overlay = _f === void 0 ? false : _f, _g = _a.color, color = _g === void 0 ? 'default' : _g, _h = _a.className, className = _h === void 0 ? '' : _h, _j = _a.dataTestId, dataTestId = _j === void 0 ? '' : _j, _k = _a.clickThrough, clickThrough = _k === void 0 ? false : _k, _l = _a.containerClassName, containerClassName = _l === void 0 ? '' : _l;
    var _m = useState(false), isResized = _m[0], setIsResized = _m[1];
    useEffect(function () {
        var handleResize = function () {
            document.documentElement.style.setProperty('--window-height', "".concat(window.innerHeight, "px"));
            setIsResized(true);
        };
        if (!relative) {
            handleResize();
        }
        else {
            setIsResized(true);
        }
    }, [relative]);
    if (!isLoading) {
        return null;
    }
    var containerClasses = classNames(relative ? styles.relative : styles.absolute, overlay && styles.overlay, clickThrough && styles.through, centered && styles.wrapper, containerClassName);
    var spinnerClasses = classNames(styles.spinner, styles[size], styles[color], className);
    return React.createElement("div", { className: containerClasses }, isResized && React.createElement("div", { className: spinnerClasses, id: dataTestId }));
}

export { LoadingSpinner as default };
